<bau365-shell-layout
  [isLoggedIn]="isLoggedIn"
  [showFooter]="showFooter$ | async"
  (logout)="logout()"></bau365-shell-layout>
